<template>
  <share-popover
    :category="category"
    :context="context"
    :flashcard="flashcard"
    :popover-title="title"
    :popover-description="text"
    :share-messsage="message"
    share-text="SHARE"
    :url="url"
  />
</template>

<script>
import SharePopover from '@components/share/sharePopover.vue';

export default {
  components: { SharePopover },
  props: {
    category: {
      type: Object,
    },
    context: {
      type: String,
    },
    flashcard: {
      type: Object,
    },
  },
  computed: {
    config() {
      return this.$store.getters['productVars/get']['flashcardShareMessage']?.parsedValue;
    },
    message() {
      return this.config?.message_text;
    },
    title() {
      return this.config?.title || 'Ask a Friend';
    },
    text() {
      return this.config?.text || 'Share this question with a BFF.';
    },
    url() {
      if (this.flashcard && this.config) {
        let url = `${this.config.url}?fid=${this.flashcard.id}`;

        if (this.config.sc) {
          url += `&sc=${this.config.sc}`;
        }

        return url;
      }
    },
  },
};
</script>

<style>

</style>
